// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../../core/Env.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Auth__Jwt from "./Auth__Jwt.res.js";
import * as Auth__Http from "./Auth__Http.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as ApolloClient from "rescript-apollo-client/src/ApolloClient.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ApolloClient__ZenObservable from "rescript-apollo-client/src/zen-observable/ApolloClient__ZenObservable.res.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__Link_Http_HttpLink from "rescript-apollo-client/src/@apollo/client/link/http/ApolloClient__Link_Http_HttpLink.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as ApolloClient__Cache_InMemory_InMemoryCache from "rescript-apollo-client/src/@apollo/client/cache/inmemory/ApolloClient__Cache_InMemory_InMemoryCache.res.js";

let Raw = {};

let query = Client.gql(["query ShopsQuery($first: Int, $after: String)  {\nshops(first: $first, after: $after)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \ntype  \nname  \ncorporateName  \nloyaltyAddonActivated  \naddress  \npostalCode  \ncity  \ncountry  \nlegalRepresentative  \nemail  \nphoneNumber  \nlogoUri  \nbankName  \ncityOfRegistryOffice  \nwebsite  \nfiscalYearEndClosingMonth  \nlegalForm  \namountOfShareCapital  \ntvaNumber  \nsiretNumber  \nrcsNumber  \napeNafCode  \nbankCode  \nbankAccountHolder  \nbankAccountNumber  \nbicCode  \nibanNumber  \ninvoicingEndpointId  \ninvoicingEndpointIdSchemeCode  \ninvoicingEndpointIdSchemeType  \ntaxationRegime  \nemployeesNumber  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.shops;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    shops: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.type;
        let tmp;
        if (value$2 == null) {
          tmp = undefined;
        } else {
          let tmp$1;
          switch (value$2) {
            case "AFFILIATED" :
              tmp$1 = "AFFILIATED";
              break;
            case "FRANCHISED" :
              tmp$1 = "FRANCHISED";
              break;
            case "INDEPENDENT" :
              tmp$1 = "INDEPENDENT";
              break;
            case "INTEGRATED" :
              tmp$1 = "INTEGRATED";
              break;
            case "WAREHOUSE" :
              tmp$1 = "WAREHOUSE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp = tmp$1;
        }
        let value$3 = value$1.loyaltyAddonActivated;
        let value$4 = value$1.email;
        let value$5 = value$1.phoneNumber;
        let value$6 = value$1.logoUri;
        let value$7 = value$1.bankName;
        let value$8 = value$1.cityOfRegistryOffice;
        let value$9 = value$1.website;
        let value$10 = value$1.fiscalYearEndClosingMonth;
        let value$11 = value$1.legalForm;
        let value$12 = value$1.amountOfShareCapital;
        let value$13 = value$1.tvaNumber;
        let value$14 = value$1.siretNumber;
        let value$15 = value$1.rcsNumber;
        let value$16 = value$1.apeNafCode;
        let value$17 = value$1.bankCode;
        let value$18 = value$1.bankAccountHolder;
        let value$19 = value$1.bankAccountNumber;
        let value$20 = value$1.bicCode;
        let value$21 = value$1.ibanNumber;
        let value$22 = value$1.invoicingEndpointId;
        let value$23 = value$1.invoicingEndpointIdSchemeCode;
        let value$24 = value$1.invoicingEndpointIdSchemeType;
        let tmp$2;
        if (value$24 == null) {
          tmp$2 = undefined;
        } else {
          let tmp$3;
          switch (value$24) {
            case "BE_BCE" :
              tmp$3 = "BE_BCE";
              break;
            case "BE_TVA" :
              tmp$3 = "BE_TVA";
              break;
            case "FR_SIREN" :
              tmp$3 = "FR_SIREN";
              break;
            case "FR_SIREN_SIRET" :
              tmp$3 = "FR_SIREN_SIRET";
              break;
            case "FR_SIREN_SIRET_CODEROUTAGE" :
              tmp$3 = "FR_SIREN_SIRET_CODEROUTAGE";
              break;
            case "FR_SIREN_SUFFIX" :
              tmp$3 = "FR_SIREN_SUFFIX";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$2 = tmp$3;
        }
        let value$25 = value$1.taxationRegime;
        let tmp$4;
        if (value$25 == null) {
          tmp$4 = undefined;
        } else {
          let tmp$5;
          switch (value$25) {
            case "BASIC_VAT_EXEMPTION" :
              tmp$5 = "BASIC_VAT_EXEMPTION";
              break;
            case "NORMAL_MONTHLY" :
              tmp$5 = "NORMAL_MONTHLY";
              break;
            case "NORMAL_QUARTERLY" :
              tmp$5 = "NORMAL_QUARTERLY";
              break;
            case "OTHER" :
              tmp$5 = "OTHER";
              break;
            case "SIMPLIFIED" :
              tmp$5 = "SIMPLIFIED";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$4 = tmp$5;
        }
        let value$26 = value$1.employeesNumber;
        let tmp$6;
        if (value$26 == null) {
          tmp$6 = undefined;
        } else {
          let tmp$7;
          switch (value$26) {
            case "AT_LEAST_251" :
              tmp$7 = "AT_LEAST_251";
              break;
            case "FROM_11_TO_20" :
              tmp$7 = "FROM_11_TO_20";
              break;
            case "FROM_1_TO_10" :
              tmp$7 = "FROM_1_TO_10";
              break;
            case "FROM_21_TO_50" :
              tmp$7 = "FROM_21_TO_50";
              break;
            case "FROM_51_TO_250" :
              tmp$7 = "FROM_51_TO_250";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$6 = tmp$7;
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            type: tmp,
            name: value$1.name,
            corporateName: value$1.corporateName,
            loyaltyAddonActivated: !(value$3 == null) ? value$3 : undefined,
            address: value$1.address,
            postalCode: value$1.postalCode,
            city: value$1.city,
            country: value$1.country,
            legalRepresentative: value$1.legalRepresentative,
            email: !(value$4 == null) ? value$4 : undefined,
            phoneNumber: !(value$5 == null) ? value$5 : undefined,
            logoUri: !(value$6 == null) ? value$6 : undefined,
            bankName: !(value$7 == null) ? value$7 : undefined,
            cityOfRegistryOffice: !(value$8 == null) ? value$8 : undefined,
            website: !(value$9 == null) ? value$9 : undefined,
            fiscalYearEndClosingMonth: !(value$10 == null) ? value$10 : undefined,
            legalForm: !(value$11 == null) ? value$11 : undefined,
            amountOfShareCapital: !(value$12 == null) ? value$12 : undefined,
            tvaNumber: !(value$13 == null) ? value$13 : undefined,
            siretNumber: !(value$14 == null) ? value$14 : undefined,
            rcsNumber: !(value$15 == null) ? value$15 : undefined,
            apeNafCode: !(value$16 == null) ? value$16 : undefined,
            bankCode: !(value$17 == null) ? value$17 : undefined,
            bankAccountHolder: !(value$18 == null) ? value$18 : undefined,
            bankAccountNumber: !(value$19 == null) ? value$19 : undefined,
            bicCode: !(value$20 == null) ? value$20 : undefined,
            ibanNumber: !(value$21 == null) ? value$21 : undefined,
            invoicingEndpointId: !(value$22 == null) ? value$22 : undefined,
            invoicingEndpointIdSchemeCode: !(value$23 == null) ? value$23 : undefined,
            invoicingEndpointIdSchemeType: tmp$2,
            taxationRegime: tmp$4,
            employeesNumber: tmp$6
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.shops;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.employeesNumber;
    let employeesNumber = value$2 !== undefined ? (
        value$2 === "FROM_51_TO_250" ? "FROM_51_TO_250" : (
            value$2 === "FROM_11_TO_20" ? "FROM_11_TO_20" : (
                value$2 === "FROM_21_TO_50" ? "FROM_21_TO_50" : (
                    value$2 === "AT_LEAST_251" ? "AT_LEAST_251" : "FROM_1_TO_10"
                  )
              )
          )
      ) : null;
    let value$3 = value$1.taxationRegime;
    let taxationRegime = value$3 !== undefined ? (
        value$3 === "NORMAL_QUARTERLY" ? "NORMAL_QUARTERLY" : (
            value$3 === "BASIC_VAT_EXEMPTION" ? "BASIC_VAT_EXEMPTION" : (
                value$3 === "NORMAL_MONTHLY" ? "NORMAL_MONTHLY" : (
                    value$3 === "OTHER" ? "OTHER" : "SIMPLIFIED"
                  )
              )
          )
      ) : null;
    let value$4 = value$1.invoicingEndpointIdSchemeType;
    let invoicingEndpointIdSchemeType = value$4 !== undefined ? (
        value$4 === "BE_TVA" ? "BE_TVA" : (
            value$4 === "FR_SIREN" ? "FR_SIREN" : (
                value$4 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : (
                    value$4 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : (
                        value$4 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE"
                      )
                  )
              )
          )
      ) : null;
    let value$5 = value$1.invoicingEndpointIdSchemeCode;
    let invoicingEndpointIdSchemeCode = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.invoicingEndpointId;
    let invoicingEndpointId = value$6 !== undefined ? value$6 : null;
    let value$7 = value$1.ibanNumber;
    let ibanNumber = value$7 !== undefined ? value$7 : null;
    let value$8 = value$1.bicCode;
    let bicCode = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.bankAccountNumber;
    let bankAccountNumber = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.bankAccountHolder;
    let bankAccountHolder = value$10 !== undefined ? value$10 : null;
    let value$11 = value$1.bankCode;
    let bankCode = value$11 !== undefined ? value$11 : null;
    let value$12 = value$1.apeNafCode;
    let apeNafCode = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.rcsNumber;
    let rcsNumber = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.siretNumber;
    let siretNumber = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.tvaNumber;
    let tvaNumber = value$15 !== undefined ? value$15 : null;
    let value$16 = value$1.amountOfShareCapital;
    let amountOfShareCapital = value$16 !== undefined ? value$16 : null;
    let value$17 = value$1.legalForm;
    let legalForm = value$17 !== undefined ? value$17 : null;
    let value$18 = value$1.fiscalYearEndClosingMonth;
    let fiscalYearEndClosingMonth = value$18 !== undefined ? value$18 : null;
    let value$19 = value$1.website;
    let website = value$19 !== undefined ? value$19 : null;
    let value$20 = value$1.cityOfRegistryOffice;
    let cityOfRegistryOffice = value$20 !== undefined ? value$20 : null;
    let value$21 = value$1.bankName;
    let bankName = value$21 !== undefined ? value$21 : null;
    let value$22 = value$1.logoUri;
    let logoUri = value$22 !== undefined ? value$22 : null;
    let value$23 = value$1.phoneNumber;
    let phoneNumber = value$23 !== undefined ? value$23 : null;
    let value$24 = value$1.email;
    let email = value$24 !== undefined ? value$24 : null;
    let value$25 = value$1.legalRepresentative;
    let value$26 = value$1.country;
    let value$27 = value$1.city;
    let value$28 = value$1.postalCode;
    let value$29 = value$1.address;
    let value$30 = value$1.loyaltyAddonActivated;
    let loyaltyAddonActivated = value$30 !== undefined ? value$30 : null;
    let value$31 = value$1.corporateName;
    let value$32 = value$1.name;
    let value$33 = value$1.type;
    let type_ = value$33 !== undefined ? (
        value$33 === "WAREHOUSE" ? "WAREHOUSE" : (
            value$33 === "INTEGRATED" ? "INTEGRATED" : (
                value$33 === "INDEPENDENT" ? "INDEPENDENT" : (
                    value$33 === "AFFILIATED" ? "AFFILIATED" : "FRANCHISED"
                  )
              )
          )
      ) : null;
    let value$34 = value$1.id;
    let value$35 = value$1.__typename;
    let node = {
      __typename: value$35,
      id: value$34,
      type: type_,
      name: value$32,
      corporateName: value$31,
      loyaltyAddonActivated: loyaltyAddonActivated,
      address: value$29,
      postalCode: value$28,
      city: value$27,
      country: value$26,
      legalRepresentative: value$25,
      email: email,
      phoneNumber: phoneNumber,
      logoUri: logoUri,
      bankName: bankName,
      cityOfRegistryOffice: cityOfRegistryOffice,
      website: website,
      fiscalYearEndClosingMonth: fiscalYearEndClosingMonth,
      legalForm: legalForm,
      amountOfShareCapital: amountOfShareCapital,
      tvaNumber: tvaNumber,
      siretNumber: siretNumber,
      rcsNumber: rcsNumber,
      apeNafCode: apeNafCode,
      bankCode: bankCode,
      bankAccountHolder: bankAccountHolder,
      bankAccountNumber: bankAccountNumber,
      bicCode: bicCode,
      ibanNumber: ibanNumber,
      invoicingEndpointId: invoicingEndpointId,
      invoicingEndpointIdSchemeCode: invoicingEndpointIdSchemeCode,
      invoicingEndpointIdSchemeType: invoicingEndpointIdSchemeType,
      taxationRegime: taxationRegime,
      employeesNumber: employeesNumber
    };
    let value$36 = value.__typename;
    return {
      __typename: value$36,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let shops = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    shops: shops
  };
}

function serializeVariables(inp) {
  let a = inp.first;
  let a$1 = inp.after;
  return {
    first: a !== undefined ? a : undefined,
    after: a$1 !== undefined ? a$1 : undefined
  };
}

function makeVariables(first, after) {
  return {
    first: first,
    after: after
  };
}

function makeDefaultVariables() {
  return {
    first: undefined,
    after: undefined
  };
}

let ShopsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let ShopsQuery_refetchQueryDescription = include.refetchQueryDescription;

let ShopsQuery_use = include.use;

let ShopsQuery_useLazy = include.useLazy;

let ShopsQuery_useLazyWithVariables = include.useLazyWithVariables;

let ShopsQuery = {
  ShopsQuery_inner: ShopsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: ShopsQuery_refetchQueryDescription,
  use: ShopsQuery_use,
  useLazy: ShopsQuery_useLazy,
  useLazyWithVariables: ShopsQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query DevicesQuery($first: Int, $after: String)  {\ndevices(first: $first, after: $after, filterBy: {name: {_equals: \"Web\"}, slug: {_equals: \"W\"}})  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.devices;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    devices: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize$1(value) {
  let value$1 = value.devices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.id;
    let value$6 = value$1.__typename;
    let node = {
      __typename: value$6,
      id: value$5,
      shop: shop
    };
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let devices = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    devices: devices
  };
}

function serializeVariables$1(inp) {
  let a = inp.first;
  let a$1 = inp.after;
  return {
    first: a !== undefined ? a : undefined,
    after: a$1 !== undefined ? a$1 : undefined
  };
}

function makeVariables$1(first, after) {
  return {
    first: first,
    after: after
  };
}

function makeDefaultVariables$1() {
  return {
    first: undefined,
    after: undefined
  };
}

let DevicesQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  makeDefaultVariables: makeDefaultVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let DevicesQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let DevicesQuery_use = include$1.use;

let DevicesQuery_useLazy = include$1.useLazy;

let DevicesQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let DevicesQuery = {
  DevicesQuery_inner: DevicesQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  makeDefaultVariables: makeDefaultVariables$1,
  refetchQueryDescription: DevicesQuery_refetchQueryDescription,
  use: DevicesQuery_use,
  useLazy: DevicesQuery_useLazy,
  useLazyWithVariables: DevicesQuery_useLazyWithVariables
};

let httpLink = ApolloClient__Link_Http_HttpLink.make(param => Env.gatewayUrl() + "/graphql", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function authMiddleware(jwt) {
  return ReasonMLCommunity__ApolloClient.Link.make((operation, forward) => {
    operation.setContext(Auth__Http.encodeHttpContext(jwt));
    return ApolloClient__ZenObservable.Observable.fromJs(forward(operation));
  });
}

function fetchShops(client, previousShopsOpt, firstOpt, after, param) {
  let previousShops = previousShopsOpt !== undefined ? previousShopsOpt : [];
  let first = firstOpt !== undefined ? firstOpt : 50;
  return Future.flatMap(FuturePromise.fromPromise(client.rescript_query({
    query: query,
    Raw: Raw,
    parse: parse,
    serialize: serialize,
    serializeVariables: serializeVariables
  }, undefined, undefined, "NetworkOnly", undefined, {
    first: first,
    after: after
  })), undefined, result => {
    if (result.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
    let match = result._0;
    if (match.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
    let match$1 = match._0;
    if (match$1.error !== undefined) {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
    let match$2 = match$1.data.shops;
    let pageInfo = match$2.pageInfo;
    let shops = Belt_Array.concatMany([
      previousShops,
      match$2.edges.map(edge => edge.node)
    ]);
    let endCursor = pageInfo.endCursor;
    if (endCursor !== undefined) {
      let match$3 = pageInfo.hasNextPage;
      if (match$3 !== undefined && match$3) {
        return fetchShops(client, shops, first, endCursor, undefined);
      } else {
        return Future.value({
          TAG: "Ok",
          _0: shops
        });
      }
    }
    let match$4 = pageInfo.hasNextPage;
    if (match$4 !== undefined && match$4) {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    } else {
      return Future.value({
        TAG: "Ok",
        _0: shops
      });
    }
  });
}

function fetchWebDevices(client, previousDevicesOpt, firstOpt, after, param) {
  let previousDevices = previousDevicesOpt !== undefined ? previousDevicesOpt : [];
  let first = firstOpt !== undefined ? firstOpt : 50;
  return Future.flatMap(FuturePromise.fromPromise(client.rescript_query({
    query: query$1,
    Raw: Raw$1,
    parse: parse$1,
    serialize: serialize$1,
    serializeVariables: serializeVariables$1
  }, undefined, undefined, "NetworkOnly", undefined, {
    first: first,
    after: after
  })), undefined, result => {
    if (result.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
    let match = result._0;
    if (match.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
    let match$1 = match._0;
    if (match$1.error !== undefined) {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
    let match$2 = match$1.data.devices;
    let pageInfo = match$2.pageInfo;
    let devices = Belt_Array.concatMany([
      previousDevices,
      match$2.edges.map(edge => edge.node)
    ]);
    let endCursor = pageInfo.endCursor;
    if (endCursor !== undefined) {
      let match$3 = pageInfo.hasNextPage;
      if (match$3 !== undefined && match$3) {
        return fetchWebDevices(client, devices, first, endCursor, undefined);
      } else {
        return Future.value({
          TAG: "Ok",
          _0: devices
        });
      }
    }
    let match$4 = pageInfo.hasNextPage;
    if (match$4 !== undefined && match$4) {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    } else {
      return Future.value({
        TAG: "Ok",
        _0: devices
      });
    }
  });
}

function fetchShopsWithWebDevice(jwt) {
  let client = ApolloClient.make(undefined, undefined, undefined, Primitive_option.some(ReasonMLCommunity__ApolloClient.Link.from([
    authMiddleware(jwt),
    httpLink
  ])), ApolloClient__Cache_InMemory_InMemoryCache.make(undefined, undefined, undefined, undefined, undefined, undefined), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let shopsRequest = fetchShops(client, undefined, undefined, undefined, undefined);
  let devicesRequest = fetchWebDevices(client, undefined, undefined, undefined, undefined);
  return Future.map(Future.all2([
    shopsRequest,
    devicesRequest
  ]), undefined, param => {
    let devices = param[1];
    let shops = param[0];
    if (shops.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    if (devices.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let devices$1 = devices._0;
    let shopsWithWebDevice = Stdlib_Array.filterMap(shops._0, shop => {
      let maybeWebDevice = devices$1.find(device => device.shop.id === shop.id);
      if (maybeWebDevice !== undefined) {
        return {
          id: shop.id,
          kind: Stdlib_Option.getOr(shop.type, "INDEPENDENT"),
          name: shop.name,
          corporateName: shop.corporateName,
          address: shop.address,
          postalCode: shop.postalCode,
          city: shop.city,
          country: shop.country,
          phoneNumber: Stdlib_Option.getOr(shop.phoneNumber, "?"),
          email: Stdlib_Option.getOr(shop.email, "?"),
          legalRepresentative: shop.legalRepresentative,
          logoUri: shop.logoUri,
          activeWebDeviceId: maybeWebDevice.id,
          loyaltyAddonActivated: Stdlib_Option.getOr(shop.loyaltyAddonActivated, false),
          bankName: shop.bankName,
          cityOfRegistryOffice: shop.cityOfRegistryOffice,
          website: shop.website,
          fiscalYearEndClosingMonth: shop.fiscalYearEndClosingMonth,
          legalForm: shop.legalForm,
          amountOfShareCapital: shop.amountOfShareCapital,
          tvaNumber: shop.tvaNumber,
          siretNumber: shop.siretNumber,
          rcsNumber: shop.rcsNumber,
          apeNafCode: shop.apeNafCode,
          bankCode: shop.bankCode,
          bankAccountHolder: shop.bankAccountHolder,
          bankAccountNumber: shop.bankAccountNumber,
          bicCode: shop.bicCode,
          ibanNumber: shop.ibanNumber,
          invoicingEndpointId: shop.invoicingEndpointId,
          invoicingEndpointIdSchemeCode: shop.invoicingEndpointIdSchemeCode,
          invoicingEndpointIdSchemeType: shop.invoicingEndpointIdSchemeType,
          taxationRegime: shop.taxationRegime,
          employeesNumber: shop.employeesNumber
        };
      }
    });
    if (shopsWithWebDevice.length !== 0) {
      return {
        TAG: "Ok",
        _0: shopsWithWebDevice
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
}

function decodeUserResultWithJwt(userResult, jwt) {
  let maybeUserDict = Json.decodeDict(userResult);
  let maybeUserScopeDict = Json.flatDecodeDictFieldDict(maybeUserDict, "scope");
  if (maybeUserDict === undefined) {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  if (maybeUserScopeDict === undefined) {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  let user;
  try {
    user = {
      id: Json.decodeDictFieldExn(maybeUserDict, "id", Json.decodeString),
      name: Json.decodeDictFieldExn(maybeUserDict, "name", Json.decodeString),
      organizationName: Json.decodeDictFieldExn(maybeUserDict, "organizationName", Json.decodeString),
      profilePictureUri: Json.decodeDictOptionalField(maybeUserDict, "profilePictureUri", Json.decodeString),
      username: Json.decodeDictFieldExn(maybeUserDict, "username", Json.decodeString),
      canUseImpersonation: Stdlib_Option.getOr(Json.decodeDictOptionalField(maybeUserScopeDict, "canUseImpersonation", Json.decodeBoolean), false),
      impersonating: Auth__Jwt.isImpersonated(jwt)
    };
  } catch (exn) {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  return {
    TAG: "Ok",
    _0: user
  };
}

function fetchUser(jwt) {
  return Future.mapResult(Future.mapError(FuturePromise.fromPromise(fetch(Env.gatewayUrl() + "/users/me", {
    headers: Primitive_option.some(new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ` + jwt
    }))
  }).then(prim => prim.json())), undefined, param => {}), undefined, userResult => decodeUserResultWithJwt(userResult, jwt));
}

let ApolloLink;

let ApolloOperation;

let Observable;

let isImpersonatedJwt = Auth__Jwt.isImpersonated;

let encodeHttpContext = Auth__Http.encodeHttpContext;

export {
  ApolloLink,
  ApolloOperation,
  Observable,
  isImpersonatedJwt,
  encodeHttpContext,
  ShopsQuery,
  DevicesQuery,
  httpLink,
  authMiddleware,
  fetchShops,
  fetchWebDevices,
  fetchShopsWithWebDevice,
  decodeUserResultWithJwt,
  fetchUser,
}
/* query Not a pure module */
